import { baseStrapiURL } from './config';

export const newsletterService = {
    /**
     * Enregistre un utilisateur pour la newsletter
     * @param {Object} userData - Données utilisateur
     * @param {string} userData.email
     * @param {string} userData.prenom
     * @param {string} userData.codePostal
     * @param {string} userData.recaptchaToken - Token reCAPTCHA
     * @returns {Promise<Object>} - Réponse de l'API
     */
    async registerForNewsletter(userData) {
        try {
            
            const response = await fetch(`${baseStrapiURL}/api/newsletter/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: userData.email,
                    prenom: userData.prenom,
                    codePostal: userData.codePostal,
                    recaptchaToken: userData.recaptchaToken
                })
            });

            const result = await response.json();

            if (!response.ok) {
                console.error('Erreur API newsletter:', result);
                throw new Error(result.error?.message || 'Erreur lors de l\'enregistrement');
            }

            return result;
        } catch (error) {
            console.error('Erreur newsletter service:', error);
            throw error;
        }
    },
};